import {
  REAL_ESTATE_SCHEDULE_INTERVALS,
  getRealEstatePipelineRun,
  getRealEstatePipelineRuns,
  getRealEstatePipelineSources,
  runRealEstatePipelineSource,
  stopRealEstatePipelineSource,
  syncRealEstatePipelineSources,
  updateRealEstatePipelineSource,
} from "./midpointApi";

export { pollRunUntilComplete } from "./pollRunUntilComplete.js";

export { REAL_ESTATE_SCHEDULE_INTERVALS };

export async function fetchRealEstateSources() {
  return getRealEstatePipelineSources();
}

export async function runRealEstateSource(sourceKey, options = {}) {
  return runRealEstatePipelineSource(sourceKey, options);
}

export async function stopRealEstateSource(sourceKey, options = {}) {
  return stopRealEstatePipelineSource(sourceKey, options);
}

export async function updateRealEstateSource(sourceKey, payload) {
  const response = await updateRealEstatePipelineSource(sourceKey, payload);
  return response.source || response;
}

export async function fetchRealEstateSourceRuns(sourceKey, filters = {}) {
  return getRealEstatePipelineRuns(sourceKey, filters);
}

export async function fetchRealEstateRunById(runId) {
  return getRealEstatePipelineRun(runId);
}

export async function syncRealEstateSources() {
  return syncRealEstatePipelineSources();
}

export function schedulePayloadFromInterval(minutes, scheduleEnabled) {
  if (!scheduleEnabled || minutes == null) {
    return {
      scheduleEnabled: false,
      scheduleIntervalMinutes: null,
    };
  }

  return {
    scheduleEnabled: true,
    scheduleIntervalMinutes: minutes,
  };
}

export function intervalMinutesFromSource(source) {
  if (!source?.scheduleEnabled) {
    return null;
  }

  return source.scheduleIntervalMinutes ?? null;
}
